<template>
  <div
    @click="
      !onlyChangeOnInputClick
        ? $refs['brb-checkbox-hidden-input'].click()
        : null
    "
    :class="[
      'user-select-none d-flex',
      { 'cursor-pointer': !onlyChangeOnInputClick },
      { 'brb-checkbox': withBorder }
    ]"
  >
    <b-img
      :src="asset"
      width="20"
      height="20"
      :alt="model ? '+' : '-'"
      :class="{ 'ml-2': !!label, 'cursor-pointer': onlyChangeOnInputClick }"
      @click="
        onlyChangeOnInputClick
          ? $refs['brb-checkbox-hidden-input'].click()
          : null
      "
    />

    <span v-if="label" :class="labelClass">
      {{ label }}
    </span>

    <slot name="label"></slot>

    <input
      ref="brb-checkbox-hidden-input"
      hidden
      type="checkbox"
      v-model="model"
    />
  </div>
</template>

<script>
export default {
  name: 'BrbCheckbox',
  props: {
    value: Boolean,
    label: String,
    labelClass: [String, Array],
    onlyChangeOnInputClick: Boolean,
    circle: Boolean,
    withBorder: Boolean
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    asset() {
      return require(`@/assets/image/brb-checkbox/${
        this.circle ? 'circle' : 'default'
      }-${this.model ? 'checked' : 'unchecked'}.${this.circle ? 'svg' : 'png'}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.brb-checkbox {
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  background: transparent !important;
  width: 100%;
  border: 1px solid #3a3a3a;
  border-radius: 1rem;
  color: #3a3a3a;
  height: 3.125rem;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
</style>
